<template>
  <section class="seo-links">
    <h2>{{ title }}</h2>
    <div>
      <input
        id="checkbox-engagement-destinations"
        ref="showCheckbox"
        class="hidden-checkbox"
        type="checkbox"
        aria-hidden="true"
        tabindex="-1"
      />
      <pu-link
        v-for="item in items.slice(0, 6)"
        :key="item.url"
        :path="item.url"
      >
        {{ item.name }} {{ item.metaTitle || '' }}
      </pu-link>

      <template v-if="items.length > 6">
        <div class="additional-content">
          <pu-link
            v-for="item in items.slice(6)"
            :key="item.url"
            :path="item.url"
          >
            {{ item.name }} {{ item.metaTitle || '' }}
          </pu-link>
        </div>
        <label
          for="checkbox-engagement-destinations"
          :aria-label="$t('View more')"
        >
          <translate class="section-close-txt">View fewer</translate>
          <translate class="section-open-txt">View more</translate>
        </label>
      </template>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

interface Item {
  name: string
  url: string
  metaTitle?: string
}

@Component({})
class SearchEngagementDestinations extends Vue {
  @Prop({ required: true })
  title: string

  @Prop({ required: true })
  items: Item[]
}

export default toNative(SearchEngagementDestinations)
</script>
<style scoped>
@import url('~/assets/css/seo-links.css');
</style>
